/** CoStar.Api.SuiteDetail.TenantCompanyTenantRepCompanies.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["CompanyAsc"] = 1] = "CompanyAsc";
    SortType[SortType["CompanyDsc"] = 2] = "CompanyDsc";
    SortType[SortType["TenantLocationsAsc"] = 3] = "TenantLocationsAsc";
    SortType[SortType["TenantLocationsDsc"] = 4] = "TenantLocationsDsc";
    SortType[SortType["TenantSfOccupiedAsc"] = 5] = "TenantSfOccupiedAsc";
    SortType[SortType["TenantSfOccupiedDsc"] = 6] = "TenantSfOccupiedDsc";
    SortType[SortType["TenantRepEmployeesAsc"] = 7] = "TenantRepEmployeesAsc";
    SortType[SortType["TenantRepEmployeesDsc"] = 8] = "TenantRepEmployeesDsc";
    SortType[SortType["TenantRepLocationsAsc"] = 9] = "TenantRepLocationsAsc";
    SortType[SortType["TenantRepLocationsDsc"] = 10] = "TenantRepLocationsDsc";
    SortType[SortType["HqCityAsc"] = 11] = "HqCityAsc";
    SortType[SortType["HqCityDsc"] = 12] = "HqCityDsc";
    SortType[SortType["HqStateAsc"] = 13] = "HqStateAsc";
    SortType[SortType["HqStateDsc"] = 14] = "HqStateDsc";
    SortType[SortType["HqCountryAsc"] = 15] = "HqCountryAsc";
    SortType[SortType["HqCountryDsc"] = 16] = "HqCountryDsc";
})(SortType || (SortType = {}));
